var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.dispositivos,"loading-text":"Cargando Dispositivos","loading":_vm.isloading,"footer-props":_vm.footer,"no-data-text":"No hemos encontrado datos...","locale":"es"},scopedSlots:_vm._u([{key:"item.id_dispositivo",fn:function(ref){
var item = ref.item;
var value = ref.value;
return [_vm._v(" "+_vm._s(value)+" ")]}},{key:"item.os",fn:function(ref){
var item = ref.item;
var value = ref.value;
return [_vm._v(" "+_vm._s(value)+" ")]}},{key:"item.rango_afecto",fn:function(ref){
var item = ref.item;
var value = ref.value;
return [_vm._v(" "+_vm._s(value)+" ")]}},{key:"item.folio_afecto",fn:function(ref){
var item = ref.item;
var value = ref.value;
return [_vm._v(" "+_vm._s((value == -1 ? "" : value))+" ")]}},{key:"item.rango_exento",fn:function(ref){
var item = ref.item;
var value = ref.value;
return [_vm._v(" "+_vm._s(value)+" ")]}},{key:"item.folio_exento",fn:function(ref){
var item = ref.item;
var value = ref.value;
return [_vm._v(" "+_vm._s((value == -1 ? "" : value))+" ")]}},{key:"item.is_deshabilitado",fn:function(ref){
var item = ref.item;
var value = ref.value;
return [_c('v-checkbox',{staticClass:"align-center justify-center pt-0 mt-0",attrs:{"color":"primary","hide-details":"","readonly":""},on:{"click":function($event){return _vm.openModal(item)}},model:{value:(value),callback:function ($$v) {value=$$v},expression:"value"}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }